// Constantes para perfiles emocionales
const PROFILES = {
  DESARROLLO: 'Desarrollo',
  EQUILIBRADO: 'Equilibrado',
  EMPATICO: 'Empatico',
  COLABORATIVO: 'Colaborativo',
  AUTOCONSCIENTE: 'Autoconsciente',
  AUTORREGULADO: 'Autorregulado',
  MOTIVADO: 'Motivado',
  ESTRATEGICO: 'Estrategico',
  LIDER_INSPIRACIONAL: 'Lider inspiracional',
  INVALID_INPUT: 'Invalid input',
  PERFIL_NO_DEFINIDO: 'Perfil no definido',
};

export function getEmotionalProfileValue(totalBars, traits) {
  let {
    empatia,
    autoconocimiento,
    autorregulacion,
    motivacion,
    habilidadesSociales,
  } = traits;

  // Convertir a números para asegurar
  empatia = Number(empatia);
  autoconocimiento = Number(autoconocimiento);
  autorregulacion = Number(autorregulacion);
  motivacion = Number(motivacion);
  habilidadesSociales = Number(habilidadesSociales);

  const allTraits = [
    empatia,
    autoconocimiento,
    autorregulacion,
    motivacion,
    habilidadesSociales,
  ];

  // Validar que los traits sean de 1 a 5
  const isValid = allTraits.every(
    (val) => Number.isInteger(val) && val >= 1 && val <= 5,
  );

  if (
    !isValid ||
    typeof totalBars !== 'number' ||
    totalBars < 5 ||
    totalBars > 25
  ) {
    return PROFILES.INVALID_INPUT;
  }

  // Función helper para encontrar el máximo valor
  const max = Math.max(...allTraits);
  const isHighest = (val) => val === max;

  // 5 a 10 barras = Desarrollo
  if (totalBars >= 5 && totalBars <= 10) return PROFILES.DESARROLLO;

  // 11 a 15 barras = Equilibrado
  if (totalBars >= 11 && totalBars <= 15) return PROFILES.EQUILIBRADO;

  // 16 a 18 barras = Empático
  if (totalBars === 16 || totalBars === 17) return PROFILES.EMPATICO;

  if (totalBars === 18) {
    // Para valores de 18 barras puede ser Empático o Colaborativo
    // Si empatia posee 4 o más barras, el perfil es Empático
    // Si empatia posee 3 o menos barras, el perfil es Colaborativo
    return empatia >= 4 ? PROFILES.EMPATICO : PROFILES.COLABORATIVO;
  }

  // 19 a 21 barras: Colaborativo - Autoconsciente - Autorregulado - Motivado
  if (totalBars >= 19 && totalBars <= 21) {
    // Si empatía y habilidades sociales tienen los mismos valores, se debe verificar el valor de autoconocimiento
    if (empatia === habilidadesSociales) {
      return autoconocimiento >= 4
        ? PROFILES.AUTORREGULADO
        : PROFILES.COLABORATIVO;
    }

    // Si autoconocimiento es el eje con más barras y no es igual a ningún otro eje, el perfil es Autoconsciente
    if (
      isHighest(autoconocimiento) &&
      autoconocimiento > autorregulacion &&
      autoconocimiento > motivacion &&
      autoconocimiento > empatia &&
      autoconocimiento > habilidadesSociales
    ) {
      return PROFILES.AUTOCONSCIENTE;
    }

    // Si empatía o habilidades sociales son los ejes con más barras, el perfil es Colaborativo
    if (
      (isHighest(empatia) || isHighest(habilidadesSociales)) &&
      !isHighest(autorregulacion)
    ) {
      return PROFILES.COLABORATIVO;
    }

    // Si autorregulación es el eje con más barras (aunque comparta con empatía y/o habilidades sociales), el perfil es Autorregulado
    if (isHighest(autorregulacion)) {
      return PROFILES.AUTORREGULADO;
    }

    // Si motivación es el eje con más barras, el perfil es Motivado
    if (isHighest(motivacion)) {
      return PROFILES.MOTIVADO;
    }

    // Reglas de desempate
    // Si motivación y autorregulación tienen los mismos valores, se debe verificar el valor de autoconocimiento
    if (motivacion === autorregulacion && motivacion === max) {
      return autoconocimiento >= 4 ? PROFILES.MOTIVADO : PROFILES.AUTORREGULADO;
    }

    // Si autoconocimiento y autorregulación tienen los mismos valores, se debe verificar el valor de motivación
    if (autoconocimiento === autorregulacion && autoconocimiento === max) {
      return motivacion >= 4 ? PROFILES.AUTOCONSCIENTE : PROFILES.AUTORREGULADO;
    }
  }

  // 22 a 24 barras: Autoconsciente - Autorregulado - Motivado - Estratégico
  if (totalBars >= 22 && totalBars <= 24) {
    if (totalBars === 24) {
      // 24 barras: Estratégico - Líder inspiracional
      // Si motivación tiene 4 barras y el resto de ejes 5 barras, el perfil es Estratégico
      if (
        motivacion === 4 &&
        autoconocimiento === 5 &&
        autorregulacion === 5 &&
        empatia === 5 &&
        habilidadesSociales === 5
      ) {
        return PROFILES.ESTRATEGICO;
      }
      // Si empatía tiene 4 barras y el resto de ejes 5 barras, el perfil es Líder inspiracional
      if (
        empatia === 4 &&
        autoconocimiento === 5 &&
        autorregulacion === 5 &&
        motivacion === 5 &&
        habilidadesSociales === 5
      ) {
        return PROFILES.LIDER_INSPIRACIONAL;
      }
      // Si autoconocimiento tiene 4 barras y el resto de ejes 5 barras, el perfil es Líder inspiracional
      if (
        autoconocimiento === 4 &&
        autorregulacion === 5 &&
        motivacion === 5 &&
        empatia === 5 &&
        habilidadesSociales === 5
      ) {
        return PROFILES.LIDER_INSPIRACIONAL;
      }
      // Si autorregulación tiene 4 barras y el resto de ejes 5 barras, el perfil es Líder inspiracional
      if (
        autorregulacion === 4 &&
        autoconocimiento === 5 &&
        motivacion === 5 &&
        empatia === 5 &&
        habilidadesSociales === 5
      ) {
        return PROFILES.LIDER_INSPIRACIONAL;
      }
      // Si habilidades sociales tiene 4 barras y el resto de ejes 5 barras, el perfil es Estratégico
      if (
        habilidadesSociales === 4 &&
        autoconocimiento === 5 &&
        autorregulacion === 5 &&
        motivacion === 5 &&
        empatia === 5
      ) {
        return PROFILES.ESTRATEGICO;
      }
    }

    // Si autoconocimiento y motivación están en 5 barras, el perfil es Estratégico
    if (autoconocimiento === 5 && motivacion === 5) {
      return PROFILES.ESTRATEGICO;
    }

    // Si autoconocimiento y autorregulación están en 4 o 5 barras, se debe verificar el valor de motivación
    if (autoconocimiento >= 4 && autorregulacion >= 4) {
      return motivacion >= 4 ? PROFILES.AUTOCONSCIENTE : PROFILES.AUTORREGULADO;
    }

    // Si motivación y autorregulación están en 4 o 5 barras, se debe verificar el valor de autoconocimiento
    if (motivacion >= 4 && autorregulacion >= 4) {
      return autoconocimiento >= 4 ? PROFILES.MOTIVADO : PROFILES.AUTORREGULADO;
    }
  }

  // 23 barras: Motivado - Estratégico - Líder inspiracional
  if (totalBars === 23) {
    // Contar cuántos ejes tienen 5 barras
    const fiveCount = [
      autoconocimiento,
      autorregulacion,
      motivacion,
      empatia,
      habilidadesSociales,
    ].filter((val) => val === 5).length;

    // Si 3 ejes tienen 5 barras y uno de los ejes es Habilidades Sociales, es Líder Inspiracional. Sino es Estratégico.
    if (fiveCount === 3) {
      return habilidadesSociales === 5
        ? PROFILES.LIDER_INSPIRACIONAL
        : PROFILES.ESTRATEGICO;
    }

    // Si 4 ejes tienen 5 barras y uno de los ejes es Habilidades Sociales, es Líder Inspiracional. Sino es Estratégico.
    if (fiveCount === 4) {
      return habilidadesSociales === 5
        ? PROFILES.LIDER_INSPIRACIONAL
        : PROFILES.ESTRATEGICO;
    }

    // Reglas específicas para pares de ejes con 5 barras
    if (motivacion === 5 && autoconocimiento === 5) return PROFILES.ESTRATEGICO;
    if (motivacion === 5 && habilidadesSociales === 5)
      return PROFILES.LIDER_INSPIRACIONAL;
    if (motivacion === 5 && autorregulacion === 5) return PROFILES.MOTIVADO;
    if (empatia === 5 && autorregulacion === 5) return PROFILES.ESTRATEGICO;
    if (empatia === 5 && habilidadesSociales === 5)
      return PROFILES.LIDER_INSPIRACIONAL;
    if (autoconocimiento === 5 && habilidadesSociales === 5)
      return PROFILES.ESTRATEGICO;
    if (habilidadesSociales === 5 && autorregulacion === 5)
      return PROFILES.ESTRATEGICO;
    if (motivacion === 5 && empatia === 5) return PROFILES.MOTIVADO;
    if (autoconocimiento === 5 && empatia === 5) return PROFILES.ESTRATEGICO;
    if (autorregulacion === 5 && autoconocimiento === 5)
      return PROFILES.ESTRATEGICO;
  }

  // 25 barras = Líder inspiracional
  if (totalBars === 25) return PROFILES.LIDER_INSPIRACIONAL;

  return PROFILES.PERFIL_NO_DEFINIDO;
}
